import SectionWrapper from '@components/common/SectionWrapper'
import Besmele from '@components/shared/Icons/Besmele'
import classNames from 'classnames'
import { defaultSearchResultWithoutKuran } from 'data/homeDefaultSearchResult'
import { getNativeReaderHref } from 'helpers/nativeReaderHref'
import Link from 'next/link'
import { useState } from 'react'
import { FaSearch } from 'react-icons/fa'
import HomePageSearchModal from './HomePageSearchModal'
const featuredLinks = [
  { name: "Kuran'ı Kerim", url: '/kuran', highlight: false },
  { name: 'Dualar', url: '/dualar', highlight: false },
  ...defaultSearchResultWithoutKuran,
]

const HomePageSearchHero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <SectionWrapper>
      <div className="flex flex-col items-center">
        <div className="mx-auto w-full max-w-md">
          <div className="flex justify-center mb-4 hover:scale-105 transition-transform duration-300">
            <Besmele />
          </div>

          <div className="relative">
            <div className="group relative mb-3 transition-all duration-300">
              <button
                onClick={() => setIsModalOpen(true)}
                type="button"
                id="search"
                className="input-field text-left text-gray-400"
                aria-label="Arama yap, Ne okumak istersiniz?"
              >
                Ne okumak istersiniz?
              </button>
              <div
                className="pointer-events-none group-hover:text-green-600 top-1/2 right-4 absolute text-gray-500 transition-colors -translate-y-1/2 duration-300 transform"
                aria-hidden="true"
              >
                <FaSearch />
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-2 mt-3">
            {featuredLinks.map((link, key) => (
              <Link
                key={key}
                href={getNativeReaderHref(link.url)}
                className={classNames(
                  link.highlight
                    ? 'border border-green-500 bg-linear-to-r from-green-600 to-green-700 text-white hover:from-green-700 hover:to-green-800'
                    : 'bg-linear-to-r from-slate-600 to-slate-700 text-white hover:from-slate-700 hover:to-slate-800',
                  'flex items-center rounded-lg px-3 py-1.5 text-sm font-medium shadow-xs transition-all duration-300 hover:shadow-sm',
                )}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <HomePageSearchModal
        isOpen={isModalOpen}
        triggerCloseModal={() => setIsModalOpen(false)}
      />
    </SectionWrapper>
  )
}

export default HomePageSearchHero
